export const transactionTypesData = [
    {
        name: 'Select All',
        value: 'All'
    },
    {
        name: 'Pending/Failed',
        value: 'Pending',
    },
    {
        name: 'Add Cash',
        value: 'AddCash'
    },
    {
        name: 'Redeem',
        value: 'Redeem'
    },
    {
        name: 'Rummy - Tourney/Game',
        value: 'Rummy'
    },
    {
        name: 'Bonus Claimed',
        value: 'Bonus Claimed'
    },
    {
        name: 'Refund',
        value: 'Refund'
    },
    {
        name: 'Redeem Cancellation',
        value: 'RedeemCancel'
    },
    {
        name : 'Referral Bonus',
        value : 'Referral Bonus'
    },
    {
        name: 'Acepoint Redeem',
        value: 'AcepointRedeem'
    },
    {
        name: 'TDS Applied',
        value: 'TDSApplied'
    },
    {
        name : 'Others',
        value : 'Others'
    }
]


export const transactionTypesData1 = [
    {
        name: 'Select All',
        value: 'All'
    },
    {
        name: 'Pending/Failed',
        value: 'Pending',
    },
    {
        name: 'Add Cash',
        value: 'AddCash'
    },
    {
        name: 'Redeem',
        value: 'Redeem'
    },
    {
        name: 'Rummy - Game',
        value: 'Rummy'
    },
    {
        name: 'Bonus Claimed',
        value: 'Bonus Claimed'
    },
    {
        name: 'Refund',
        value: 'Refund'
    },
    {
        name: 'Redeem Cancellation',
        value: 'RedeemCancel'
    },
    {
        name: 'TDS Applied',
        value: 'TDSApplied'
    },
    {
        name : 'Others',
        value : 'Others'
    }
]

export const timespans = [

    {
        name: 'Last 7 Days',
        value: 7
    },
    {
        name: 'Today',
        value: 1,
    },

    {
        name: 'Last 15 Days',
        value: 15,
    },
    {
        name: 'Last 30 Days',
        value: 30
    },
]

export const allFilters = [
    'AddCash', 'Pending', 'Redeem', 'Rummy', 'Bonus Claimed', 'Refund', 'RedeemCancel', 'AcepointRedeem', 'TDSApplied','Referral Bonus', 'Others'
]

export const allFilters1 = [
    'AddCash', 'Pending','Redeem', 'Rummy', 'Bonus Claimed', 'Refund', 'RedeemCancel', 'TDSApplied', 'Others'
]

export const dummyData = [
    {
        title: 'Bonus',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Claimed',
        mode: 'Net Banking',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    },
    {
        title: 'Bonus',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Paid',
        mode: 'PhonePe',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    },
    {
        title: 'Bonus',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Pending',
        mode: 'Amazon Pay',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    },
    {
        title: 'Add Cash',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Failed',
        mode: 'UPI',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    },
    {
        title: 'Bonus',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Cancelled',
        mode: 'Net Banking',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    },
    {
        title: 'Bonus',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Paid',
        mode: 'UPI',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    },
    {
        title: 'Bonus',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Claimed',
        mode: 'Net Banking',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    },
    {
        title: 'Bonus',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Paid',
        mode: 'PhonePe',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    },
    {
        title: 'Bonus',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Pending',
        mode: 'Amazon Pay',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    },
    {
        title: 'Add Cash',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Failed',
        mode: 'UPI',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    },
    {
        title: 'Bonus',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Cancelled',
        mode: 'Net Banking',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    },
    {
        title: 'Bonus',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Paid',
        mode: 'UPI',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    },
    {
        title: 'Bonus',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Claimed',
        mode: 'Net Banking',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    },
    {
        title: 'Bonus',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Paid',
        mode: 'PhonePe',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    },
    {
        title: 'Bonus',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Pending',
        mode: 'Amazon Pay',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    },
    {
        title: 'Add Cash',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Failed',
        mode: 'UPI',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    },
    {
        title: 'Bonus',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Cancelled',
        mode: 'Net Banking',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    },
    {
        title: 'Bonus',
        date: 958219200000,
        time: '6:30 PM',
        amount: 50,
        type: 'Paid',
        mode: 'UPI',
        transactionID: 11198922293,
        bonusCode: 'BX123',
        deposits: 506,
        bonusCash: 105,
        winnings: 378,
        totalBalance: 1590
    }
]